const VERSION_SLOT_HOST = /^([a-z0-9][a-z0-9-]{0,62})\.automation-calendars-frontend\.gohighlevel\.site$/

/**
 * On a staging-versions slot the backend version is the slot name. Sending it as
 * `developer_version` makes the calendar APIs hit that slot's backend, which is how a feature
 * branch is tested end to end; every other host keeps the default routing.
 */
export const resolveDeveloperVersion = (hostname: string | undefined, mode: string): string | undefined => {
  if (mode !== 'staging' || !hostname) return undefined
  const match = VERSION_SLOT_HOST.exec(hostname.toLowerCase())
  return match ? match[1] : undefined
}
